// extracted by mini-css-extract-plugin
export default {"melodyVideo":"wJ-z","isFullWidth":"xJ-z","landingPageVideo":"yJ-z","play":"zJ-z","iframeVideo":"AJ-z","playHidden":"BJ-z","fullwidth":"CJ-z"};